exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-toolbar {\n    background-color: #211954;\n    padding-left: 16px;\n    padding-right: 16px;\n    min-height: 56px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    padding-top: 10px;\n}\n\n.logo {\n    color: #ffffff;\n    text-decoration: none;\n    font-size: 22px;\n    text-transform: uppercase;\n    font-weight: 800;\n    letter-spacing: 3px;\n    margin-top: 6px;\n    display: inline-block;\n}\n\n.logo span {\n    color: #3c78a7;\n}\n\n.header-right {\n    min-width: 600px;\n}\n\n.user-area {\n    float: right;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    color: #ffffff;\n}\n\n.user-area .profile-img {\n    float: left;\n    margin-right: 10px;\n}\n\n@media only screen and (max-width: 767px)  {\n    .header-toolbar {\n        display: block;\n    }\n    .header-right {\n        min-width: 0;\n        margin-top: 20px;\n    }\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.css
// module id = 2009
// module chunks = 0